import { render, staticRenderFns } from "./aShopDetailGroupOrders.vue?vue&type=template&id=08130a86&scoped=true"
import script from "./aShopDetailGroupOrders.vue?vue&type=script&lang=js"
export * from "./aShopDetailGroupOrders.vue?vue&type=script&lang=js"
import style0 from "./aShopDetailGroupOrders.vue?vue&type=style&index=0&id=08130a86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08130a86",
  null
  
)

export default component.exports